import { FloatingIconActionButton } from 'components/breakout/FloatingIconActionButton'
import { AdminPanelSettingsIcon } from 'components/icons/AdminPanelSettings'
import { ArrowRepeatIcon } from 'components/icons/ArrowRepeat'
import { BrainIcon } from 'components/icons/BrainIcon'
import { useStudentAssignmentCubit } from 'hooks/cubits/studentAssignment'
import { observer } from 'mobx-react-lite'
import { useCallback, useState } from 'react'
import { toast } from 'react-hot-toast'
import { useTranslation } from 'react-i18next'

export const AdminOnlyActions = observer(function AdminOnlyActions() {
  const cubit = useStudentAssignmentCubit()
  const { t } = useTranslation()
  const tScoped = useCallback(
    (key: string) => t(`student_assignment.${key}`),
    [t]
  )

  const [aiLoading, setAILoading] = useState(false)
  const [resetLoading, setResetLoading] = useState(false)

  return (
    <FloatingIconActionButton
      size="small"
      className="flex flex-col items-end"
      buttonClassName="bg-surface"
      kind="tertiary"
      Icon={AdminPanelSettingsIcon}
      aria-label={t('buttons.admin_actions')}
      actions={
        cubit.roomStateId
          ? [
              {
                text: tScoped('process_ai_again'),
                onClick: async () => {
                  setAILoading(true)
                  try {
                    const success = await cubit.startAIProcessing()
                    toast(
                      tScoped(
                        success
                          ? 'ai_processing_started'
                          : 'ai_processing_running'
                      )
                    )
                  } finally {
                    setAILoading(false)
                  }
                },
                Icon: BrainIcon,
                isLoading: aiLoading,
              },
              {
                text: tScoped('restart_case_study'),
                onClick: async () => {
                  setResetLoading(true)
                  try {
                    await cubit.resetRoomState()
                  } finally {
                    setResetLoading(false)
                  }
                },
                Icon: ArrowRepeatIcon,
                isLoading: resetLoading,
              },
            ]
          : []
      }
    />
  )
})
